/*
 *
 * PblManagementActionsModal
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 10-Jul-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import * as formikActions from 'Store/actions/formik'
import PblManagementActionsModal from './PblManagementActionsModal'
import * as PblManagementActions from 'Store/actions/pblManagement'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(dispatch),
  closePopup: () => dispatch(doPopup('')),
  submitForm: (payload) => {
    dispatch(formikActions.doSaveForm(payload))
    dispatch(PblManagementActions.doDeleteOrUpdateLink())
  }
})

const mapStateToProps = (state) => ({
  data: state.popup.popupData,
  isLoading: state?.loading?.local_deleteOrUpdatePbl || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PblManagementActionsModal)
